/** For use on mobile views.
 *  Scrolls to the element with provided id.
 */
export function scrollToElement(elementId: string, offset = 0): void {
  const element = document.getElementById(elementId);
  let top = 0;

  if (element) {
    top = element.offsetTop - offset;
  }

  document.body.scrollTop = top;
  document.documentElement.scrollTop = top;
}
